const customUserIds = [17275, 18402];

export const getUserFeatureConfig = (userId?: number | null) => {
  const hasCustomConfig = userId ? customUserIds.includes(userId) : false;
  const showCrossRampRates = userId === 18402;

  return {
    showCPGRates: !hasCustomConfig,
    showAnalytics: !hasCustomConfig,
    showDownloadReport: !hasCustomConfig,
    prioritizePhilippinesTab: hasCustomConfig,
    showCrossRampRates,
  };
};
